module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(this.section) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('div', {
    staticClass: "panel-title h4"
  }, [(_vm.section.display) ? _c('span', [_vm._v(_vm._s(_vm.section.pretty_name))]) : _c('span', {
    staticClass: "text-gray"
  }, [_vm._v(_vm._s(_vm.section.pretty_name))]), _vm._v(" "), _c('div', {
    staticClass: "columns float-right"
  }, [_c('div', {
    staticClass: "column col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-switch",
    staticStyle: {
      "bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.section.display),
      expression: "section.display"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.section.display) ? _vm._i(_vm.section.display, null) > -1 : (_vm.section.display)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.section.display,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.section, "display", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.section, "display", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.section, "display", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column col-6"
  }, [_c('button', {
    staticClass: "btn btn-sm float-right",
    on: {
      "click": function($event) {
        _vm.hidden = !_vm.hidden
      }
    }
  }, [_c('i', {
    staticClass: "icon",
    class: {
      'icon-arrow-down': _vm.hidden, 'icon-arrow-up': !_vm.hidden
    }
  })])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hidden),
      expression: "!hidden"
    }],
    staticClass: "panel-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, _vm._l((_vm.section.fields), function(f, i) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "col-3 col-sm-12"
    }, [_c('label', {
      staticClass: "form-label"
    }, [_vm._v(_vm._s(f.name))])]), _vm._v(" "), _c('div', {
      staticClass: "col-9 col-sm-12"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (f.text),
        expression: "f.text"
      }],
      staticClass: "form-input input-sm",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (f.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(f, "text", $event.target.value)
        }
      }
    })])])
  }), 0)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bf3ecbc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/docMakerSection.vue
// module id = 505
// module chunks = 1